import { render, staticRenderFns } from "./default-infos.vue?vue&type=template&id=675b5ebc&scoped=true&"
import script from "./default-infos.vue?vue&type=script&lang=js&"
export * from "./default-infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b5ebc",
  null
  
)

export default component.exports